import {
  RESET_AGENTS,
  UPDATE_AVAILABLE_AGENTS,
  CLEAR_AGENT_HISTORY,
  SET_HISTORY_FOR_AGENT,
  SET_MESSAGES_FROM_HISTORY,
} from '@/store/mutation-types';
import AgentService from '@/services/agent-service';
import { getAgentsAvailableOnOrgUnitByChannel } from '@/services/channel-service';
import { getAttendanceGroupByAgentId } from '@/services/attendance-groups-service';
import { getMessagesFromJob } from '@/services/whatsapp-messages-service';

const actions = {
  getAvailableAgents({ commit }) {
    return AgentService.availableAgents().then((response) => {
      commit(UPDATE_AVAILABLE_AGENTS, response.data);
    });
  },

  reset({ commit }) {
    commit(RESET_AGENTS);
  },

  clearAgentHistory({ commit }) {
    commit(CLEAR_AGENT_HISTORY);
  },

  getAgentHistory({ commit, dispatch }, parameters) {
    return AgentService.getAgentHistory(parameters).then((response) => {
      const history = response.data.data;
      const hasMore =
        response.data.per_page * response.data.current_page <
        response.data.total;

      commit(SET_HISTORY_FOR_AGENT, history);

      return hasMore;
    });
  },

  getMessagesFromJob({ commit }, { protocol, groupProtocol }) {
    return getMessagesFromJob(protocol).then((response) => {
      const messages = response.data.data;
      commit(SET_MESSAGES_FROM_HISTORY, { protocol, groupProtocol, messages });
      return messages;
    });
  },
  getAttendanceGroupsByAgentSelected({ commit }, agentId) {
    return getAttendanceGroupByAgentId(agentId);
  },
  getAgentsAvailableOnOrgUnitByChannel({ commit }, params) {
    return getAgentsAvailableOnOrgUnitByChannel(params);
  },
};

export default actions;
